import { createFileRoute, redirect } from '@tanstack/react-router';

import Landing from '@/components/layouts/landing';
import { SITE_DESCRIPTION, SITE_NAME } from '@/lib/constants/site';
import {
  STORAGE_KEY__OFFLINE_AUTH_SESSION,
  STORAGE_KEY__OFFLINE_AUTH_SIGNED_OUT_AT,
} from '@/lib/constants/storage';
import pageHead from '@/lib/utils/page-head';

export const Route = createFileRoute('/')({
  // Document requests redirect on the server/CDN. Client navigation must also redirect before
  // mounting the landing page, without starting the mail runtime just to check the session.
  beforeLoad: () => {
    if (typeof window === 'undefined') return;
    let cached: { session?: { expiresAt?: unknown } } | null;
    try {
      if (Number(window.localStorage.getItem(STORAGE_KEY__OFFLINE_AUTH_SIGNED_OUT_AT)) > 0) {
        return;
      }
      cached = JSON.parse(window.localStorage.getItem(STORAGE_KEY__OFFLINE_AUTH_SESSION) ?? 'null');
    } catch {
      return;
    }
    const expiresAt = cached?.session?.expiresAt;
    if (typeof expiresAt === 'string' && Date.parse(expiresAt) > Date.now()) {
      throw redirect({ to: '/login', replace: true });
    }
  },
  component: Landing,
  head: () =>
    pageHead({
      title: `${SITE_NAME}: Private AI for your work`,
      exactTitle: true,
      description: SITE_DESCRIPTION,
      path: '/',
    }),
});
